import { useAtomCallback } from "jotai/utils";
import { activeConversationSidAtom } from "../state";
import { useCallback } from "react";
import { unreadMessagesCountFamily } from "../../session/state";
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from "../chat/utils";
import { DEFAULT_WAITING_ROOM_PAGE_TITLE } from "./metadata";

export function useResetFaviconAndTitleCallback() {
  const getActiveConversationSid = useAtomCallback(
    useCallback((get) => get(activeConversationSidAtom), []),
  );
  const getUnreadMessagesCount = useAtomCallback(
    useCallback(
      (get, _set, activeConversationSid?: string) =>
        get(unreadMessagesCountFamily(activeConversationSid ?? "")),
      [],
    ),
  );

  return useCallback(() => {
    const activeConversationSid = getActiveConversationSid();
    const unreadMessagesCount = getUnreadMessagesCount(activeConversationSid);
    setFaviconAndTitleBasedOnUnreadMessagesCount(
      unreadMessagesCount,
      DEFAULT_WAITING_ROOM_PAGE_TITLE,
    );
  }, [getActiveConversationSid, getUnreadMessagesCount]);
}
